// extracted by mini-css-extract-plugin
export default {"delivery-zone":"styles_delivery-zone__zHkm2","coordinates":"styles_coordinates__25272"};